import QRCode from "react-qr-code"
import CustomDialog from "../../../core/components/ui/CustomDialog"
import { Box } from "@mui/material"

const EIDQRCodeComponent = ({open, handleClose, qrcode}) => {
    return(
        <CustomDialog
            open={open}
            onClose={handleClose}
            title="Electronic ID"
            hasDividers={true}
            content={
                <Box display={'flex'} sx={{justifyContent: 'center'}}>
                    <QRCode value={qrcode} />
                </Box>
            }
            maxWidth={"sm"}
            customStyles={{}}
        />
    )
}

export default EIDQRCodeComponent